import React from "react";
import { Disclosure, Transition } from "@headlessui/react";
import { DownArrowIcon } from "../Icons";

const ProfileAccordion = ({
  title,
  placeholder,
  startIcon,
  icon = true,
  children,
  openModal,
  setModalOpen,
}) => {
  return (
    <Disclosure>
      {({ open }) => (
        <div className="w-full relative accordion-wrapper">
          <Disclosure.Button
            className={`flex w-full justify-between items-center px-3 md:px-6 py-4 cursor-pointer
              ${
                open
                  ? "accordion-button-open"
                  : "accordion-button-default"
              }
               focus:outline-none`}
            onClick={(e) => {
              if (openModal) {
                e.preventDefault();
                setModalOpen(true);
              }
            }}
          >
            <div className="flex items-center whitespace-nowrap">
              <div className="accordion-icon">
                {startIcon}
              </div>
              <div className="flex px-3 flex-col items-start justify-start space-y-1">
                <h3 className="common-lable">{title}</h3>
                <span className="secondry-lable">
                  {placeholder}
                </span>
              </div>
            </div>
            {icon && (
              <div
                className={`flex items-center ${
                  open ? "transform rotate-180" : ""
                } transition-transform duration-300 ease-in-out`}
              >
                <DownArrowIcon />
              </div>
            )}
          </Disclosure.Button>
          {!openModal && (
            <Transition
              enter="duration-200 ease-out"
              enterFrom="opacity-0 -translate-y-6"
              enterTo="opacity-100 translate-y-0"
              leave="duration-300 ease-out"
              leaveFrom="opacity-100 translate-y-0"
              leaveTo="opacity-0 -translate-y-6"
            >
              <Disclosure.Panel className="px-6 py-5">
                {children}
              </Disclosure.Panel>
            </Transition>
          )}
        </div>
      )}
    </Disclosure>
  );
};

export default ProfileAccordion;
